import OtpInput from 'react-otp-input';
import { FormikValues, useFormikContext } from 'formik';
import type { IOTPFieldProps } from '../../types/propTypes/propTypes';

const OTPField = ({ name, customStyleClass }: IOTPFieldProps) => {
  const { values, setFieldValue, errors, touched } = useFormikContext<FormikValues>();

  const hasError = touched[name] && !!errors[name];

  return (
    <div className={`mb-4 otp-field ${customStyleClass || ''}`}>
      <div className="text-center">
        <OtpInput
          value={values[name]}
          onChange={(val) => setFieldValue(name, val)}
          numInputs={6}
          inputType="number"
          renderInput={(props, index) => (
            <input {...props} key={index} className={`otp-input ${hasError ? 'error' : ''}`} />
          )}
          containerStyle="otp-container"
        />
        {hasError && <div className="ml-2 otp-error-message">{errors[name] as string}</div>}
      </div>
    </div>
  );
};
export default OTPField;
